var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavTutorialsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15034_12027)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3017 5.83366C16.3464 5.57827 16.3347 5.31619 16.2674 5.0658C16.2001 4.81541 16.0788 4.58278 15.9121 4.38425C15.7453 4.18572 15.5371 4.0261 15.3021 3.91659C15.0671 3.80707 14.8109 3.75033 14.5517 3.75033H5.44833C5.18905 3.75033 4.93292 3.80707 4.6979 3.91659C4.46289 4.0261 4.25469 4.18572 4.08793 4.38425C3.92116 4.58278 3.79987 4.81541 3.73256 5.0658C3.66526 5.31619 3.65357 5.57827 3.69833 5.83366M14.5833 3.75033C14.6067 3.53366 14.6192 3.42616 14.6192 3.33699C14.6201 2.92507 14.4684 2.52741 14.1934 2.22071C13.9184 1.91402 13.5396 1.72003 13.13 1.67616C13.0417 1.66699 12.9333 1.66699 12.7167 1.66699H7.28333C7.06666 1.66699 6.95749 1.66699 6.86916 1.67616C6.45958 1.72003 6.08075 1.91402 5.80576 2.22071C5.53077 2.52741 5.37909 2.92507 5.37999 3.33699C5.37999 3.42616 5.39166 3.53449 5.41583 3.75033M12.1508 11.347C12.6167 11.6353 12.6167 12.382 12.1508 12.6703L9.34166 14.412C8.88916 14.6928 8.33333 14.3287 8.33333 13.7503V10.267C8.33333 9.68949 8.88916 9.32533 9.34166 9.60533L12.1508 11.347Z",
    stroke: "currentColor",
    strokeWidth: 1.25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.98666 11.4948C1.61416 8.85815 1.42832 7.54065 2.21832 6.68648C3.00832 5.83398 4.41499 5.83398 7.22666 5.83398H12.7733C15.585 5.83398 16.9917 5.83398 17.7817 6.68732C18.5717 7.54065 18.385 8.85815 18.0133 11.4948L17.6617 13.9948C17.37 16.0615 17.2242 17.0957 16.4767 17.7148C15.7292 18.334 14.6267 18.334 12.4208 18.334H7.57916C5.37416 18.334 4.27082 18.334 3.52332 17.7148C2.77582 17.0957 2.62999 16.0623 2.33832 13.9948L1.98666 11.4948Z",
    stroke: "currentColor",
    strokeWidth: 1.25
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15034_12027"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavTutorialsIcon);
export default __webpack_public_path__ + "static/media/NavTutorialsIcon.3b08e5b8ca082c354e902e76a2e6a275.svg";
export { ForwardRef as ReactComponent };